// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"389":"117e08fd","885":"4b3b3015"}[chunkId] + ".chunk.js");